import AddIcon from "@mui/icons-material/Add";
import HelpIcon from '@mui/icons-material/Help';
import {
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Grid,
  Tooltip,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import clsx from "clsx";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Footer from "../../components/footer";
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars";
import MyMaterialTable from "../../components/table";
import { AbilityContext, Can } from "../../config/ability-context";
import * as componentActions from "../../redux/actions/calledclassifications";
import Api from "../../services/api";
import { Overlay } from "../../styles/global";
import { Styles } from "../../styles/material-styles";

import ClearIcon from "@mui/icons-material/Clear";
import Search from "@mui/icons-material/Search";
import Pagination from "@mui/material/Pagination";
import TextField from "@mui/material/TextField";
import RatingElement from "../../components/rating-element";
import SimpleSelect from "../../components/select/simple-search";
import { PapiroConsole } from "../../utils/papiroConsole";

class CalledClassifications extends Component {
  constructor(props) {
    super(props);

    this.typingTimeout = null;

    const { userSession } = this.props;
    var attr = "Atribuído para";
    var bool = true;
    this.globalAdm = false;
    this.AdmOrganization = false;
    this.isCoordenator = false;
    this.isTechinical = false;
    this.isClient = true;
    const intl = this.props.intl;

    if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
      Api.logoff();
    }

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3) {
        this.isClient = false;
        attr = intl.formatMessage({ id: "client" });
        bool = false;
      }
      if (item.role.roletype == 0) {
        this.globalAdm = true;
      }
      if (item.role.roletype == 1) {
        this.AdmOrganization = true;
      }
      if (item.role.roletype == 4) {
        this.isCoordenator = true;
      }
      if (item.role.roletype == 2) {
        this.isTechinical = true;
      }
    });

    let filters = [
      { name: "Id", id: "id" },
      { name: intl.formatMessage({ id: "title" }), id: "title" },
      { name: intl.formatMessage({ id: "type" }), id: "type" },
      { name: intl.formatMessage({ id: "client" }), id: "both" },
      { name: intl.formatMessage({ id: "origin.of.survey.response" }), id: "originofsurveyresponse" },
    ];

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      resultList: [],
      userId: userSession.user.id,
      userRoleName: attr,
      userRoleBool: bool,

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      searchValue: "",
      filterSelected: 0,
      filters: filters,
      originOfSurveyResponseList : [],
      activeTooltipOriginOfSurvey : false,
    };
    this.closeNotification = this.closeNotification.bind(this);
    this.getItens = this.getItens.bind(this);
    this.changeValues = this.changeValues.bind(this);

    this.callSearch = this.callSearch.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.location.state === "reload") {
  //     this.componentDidMount();
  //   }
  // }

  async componentDidMount() {
    await this.getAllOriginOfSurveyResponse();
    await this.getItens();
  }


  async getAllOriginOfSurveyResponse(){

    let url = `/calledclassifications/survey-response-origins`;
    await Api.get(url)
      .then((result) => {
        if (result.data.success) {

          this.setState({
            originOfSurveyResponseList : result.data.data
          })


        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
                result.data.response &&
                result.data.response.data &&
                result.data.response.data.errors &&
                result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
              err.response.data &&
              err.response.data.errors &&
              err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page });
    this.getItens(page);
  };

  setPagination(count, page) {
    let totalPage = Math.ceil(count / 10);
    this.setState({ totalPages: totalPage });
    if (count > 0) {
      if (page == 1) {
        if (count < 10) {
          this.setState({ pageStart: 1, pageEnd: count });
        } else {
          this.setState({ pageStart: 1, pageEnd: 10 });
        }
      } else {
        let pageStart = (page - 1) * 10 + 1;

        if (count >= page * 10) {
          this.setState({ pageStart: pageStart, pageEnd: page * 10 });
        } else {
          this.setState({ pageStart: pageStart, pageEnd: count });
        }
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0 });
    }
  }

  onFieldChange(event) {
    this.setState({ [event.target.name]: event.target.value, page: 1 });
  }

  callSearch() {
    if (this.state.filterSelected != 0) {
      this.getItens(this.state.page);
    }
  }

  async clearFields() {
    await this.setState({ filterSelected: 0, searchValue: "", page: 1 });
    this.getItens(1);
  }

  async changeValues(stateName, value, text = "") {

   
    if(value == "originofsurveyresponse"){

      this.setState({activeTooltipOriginOfSurvey : true })
    }
    else{
      this.setState({activeTooltipOriginOfSurvey : false })
    }
    this.setState({ filterSelected: value });
  }

  returnOriginOfSurveyResponse(value) {

    if(this.state.originOfSurveyResponseList && this.state.originOfSurveyResponseList.length > 0){

        var response = this.state.originOfSurveyResponseList.find(c=> c.id == value)

        if(response != null){
          return response.name;
        }
        return "";
    }
    else{
      switch (value) {
        case 1:
            return "Portal";
        case 2:
            return "Criação de chamado";
        case 3:
            return "Notificação";
        case 4:
            return "Email";
        case 5:
            return "WhatsApp";
        default:
            return "";
      }
    }
      

  }

  async getItens(page = 1) {
    const { userSession } = this.props;
    this.setState({ loading: true });

    let url = `/calleds/classifications/paginate/${this.state.userId}?page=${page}`;

    if (this.state.searchValue != "" && this.state.filterSelected != 0) {
      url += `&search=${this.state.searchValue}&field=${this.state.filterSelected}`;
    }
    PapiroConsole.log("url aqui")
    PapiroConsole.log(url)
    await Api.get(url)
      .then((result) => {
        if (result.data.success) {
          let count = result.data.count;
          this.setState({ count: count });
          this.setPagination(count, page);

          const formattedList = result.data.data.map((item) => {

            if (item.calledclassification) {
              //console.log("item.calledclassification")
              //console.log(item.calledclassification)
              //console.log(item.calledclassification.noteassigned)
              //console.log(typeof item.calledclassification.noteassigned)
            }
            let type
            if (!item.satisfactionsurvey) {
              type = 6
            } else {
              type = item.satisfactionsurvey?.satisfactionsurveyquestions?.[0]?.satisfactionsurveyquestionstypeid || 6
            }

          

            return {
              ...item,
              CalledClassificationsId: item.calledclassification
                ? item.calledclassification.id
                : 0,
              CalledId: item ? item.id : 0,
              Note: item.calledclassification && item.calledclassification.noteassigned != undefined ? item.calledclassification.noteassigned : null,
              NoteType: type,
              NoteRequest: item.calledclassification && item.calledclassification.noterequest && item.calledclassification.noterequest > 0 ? item.calledclassification.noterequest : null,
              CalledText: item.title ? item.title : "",
              OpeningDate: item
                ? moment(item.openingdate).format("DD/MM/YYYY HH:mm")
                : "",
              Type: item?.type?.name ? item.type.name : "",
              AssignedUserText: item.assigneduser ? item.assigneduser.name : "",
              Requestinguser: item.requestinguser
                ? item.requestinguser.name
                : "",
                OriginOfSurveyResponse : item.calledclassification && item.calledclassification.originofsurveyresponse ? this.returnOriginOfSurveyResponse(item.calledclassification.originofsurveyresponse) : null
            };
          });




          this.setState({ loading: false, resultList: formattedList });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
                result.data.response &&
                result.data.response.data &&
                result.data.response.data.errors &&
                result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
              err.response.data &&
              err.response.data.errors &&
              err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  }

  closeNotification() {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const intl = this.props.intl;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container
            component="main"
            maxWidth="100%"
            style={{ paddingLeft: 0, marginLeft: 0, marginRight: 0 }}
          >
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card className="background-title-search">
                  <CardContent>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item container xs={12} sm={12} md={12} lg={3} spacing={2}>
                        <Grid item>
                          <Typography variant="h5" mar>
                            {
                              <FormattedMessage id="menu.called.classifications" />
                            }
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Tooltip style={{ cursor: 'pointer' }} title={intl.formatMessage({ id: 'called.classification.list.last.note' })}>
                            <HelpIcon />
                          </Tooltip>
                        </Grid>
                      </Grid>
                      {this.state.activeTooltipOriginOfSurvey && 
                        <Grid item md={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Tooltip style={{ cursor: 'pointer' }} title={intl.formatMessage({ id: 'survey.response.source.options' })}>
                            <HelpIcon />
                          </Tooltip>
                        </Grid>
                      }
                      

                      <Grid item xs={5} sm={5} md={3} lg={3} >
                        <SimpleSelect
                          label={intl.formatMessage({ id: "field" })}
                          options={this.state.filters}
                          stateName="filter"
                          changeSelect={this.changeValues}
                          selected={this.state.filterSelected}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={4} lg={3}>
                        <TextField
                          type="text"
                          name="searchValue"
                          value={this.state.searchValue}
                          placeholder={intl.formatMessage({ id: "search" })}
                          onChange={this.onFieldChange}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          className={classes.button}
                          style={{ marginRight: 4, marginLeft: 8 }}
                          onClick={this.callSearch}
                        >
                          <Search />
                        </Button>
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={1}>
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          onClick={this.clearFields}
                          className={classes.button}
                        >
                          <ClearIcon />
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Can I="List" a="CalledClassification">
              <MyMaterialTable
                title=""
                rowClick={(event, rowData) => {
                  this.props.addCurrent(rowData);
                  if (rowData.CalledClassificationsId == 0) {
                    this.props.history.push(
                      `/${this.props.match.params.lang}/calledclassification-registration`
                    );
                  } else {
                    this.props.history.push(
                      `/${this.props.match.params.lang}/calledclassification-edit`
                    );
                  }
                }}
                columns={this.isClient ? ([
                  {
                    title: "ID",
                    field: "id",
                  },
                  {
                    title: intl.formatMessage({ id: "called" }),
                    field: "CalledText",
                  },
                  { title: intl.formatMessage({ id: "type" }), field: "Type" },
                  {
                    title: intl.formatMessage({ id: "open.date" }),
                    field: "OpeningDate",
                  },
                  {
                    title: "Atribuído para",
                    field: "AssignedUserText",
                  },
                  {
                    title: intl.formatMessage({ id: "csat.requester.to.assigned" }),
                    field: "Note",
                    render: rowData =>
                      rowData.Note != null
                        ? <RatingElement type={rowData.NoteType || 6} value={rowData.Note} />
                        : "N/A",
                  },
                  {
                    title: intl.formatMessage({ id: "client" }),
                    field: "Requestinguser"
                  },
                ])
                  :
                  (!this.globalAdm && !this.AdmOrganization && !this.isCoordenator) ? ([
                    {
                      title: "ID",
                      field: "id",
                    },
                    {
                      title: intl.formatMessage({ id: "called" }),
                      field: "CalledText",
                    },
                    { title: intl.formatMessage({ id: "type" }), field: "Type" },
                    {
                      title: intl.formatMessage({ id: "open.date" }),
                      field: "OpeningDate",
                    },
                    {
                      title: "Atribuído para",
                      field: "AssignedUserText",
                    },
                    {
                      title: intl.formatMessage({ id: "client" }),
                      field: "Requestinguser"
                    },
                    {
                      title: <div>{intl.formatMessage({ id: "csat.requester.to.assigned" })}<AddIcon /></div>,
                      field: "NoteRequest",
                      render: rowData =>
                        rowData.NoteRequest != null
                          ? <Rating name="read-only" value={rowData.NoteRequest} readOnly />
                          : "N/A",
                    },
                  ])
                    :
                    ([
                      {
                        title: "ID",
                        field: "id",
                      },
                      {
                        title: intl.formatMessage({ id: "called" }),
                        field: "CalledText",
                      },
                      { title: intl.formatMessage({ id: "type" }), field: "Type" },
                      {
                        title: intl.formatMessage({ id: "open.date" }),
                        field: "OpeningDate",
                      },
                      {
                        title: "Atribuído para",
                        field: "AssignedUserText",
                      },
                      {
                        title: intl.formatMessage({ id: "csat.requester.to.assigned" }),
                        field: "Note",
                        render: rowData =>
                          rowData.Note != null
                            ? <RatingElement type={rowData.NoteType || 6} value={rowData.Note} />
                            : "N/A",
                      },
                      {
                        title: intl.formatMessage({ id: "client" }),
                        field: "Requestinguser"
                      },
                      {
                        title: intl.formatMessage({ id: "csat.assigned.to.requester" }),
                        field: "NoteRequest",
                        render: rowData =>
                          rowData.NoteRequest != null
                            ? <Rating name="read-only" value={rowData.NoteRequest} readOnly />
                            : "N/A",
                      },
                      {
                        title: intl.formatMessage({ id: "origin.of.survey.response" }),
                        field: "OriginOfSurveyResponse",
                      },
                      
                      
                    ])
                }
                data={this.state.resultList}
              />
            </Can>
            <Can I="List" a="CalledClassification">
              <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                  <Pagination
                    count={this.state.totalPages}
                    page={this.state.page}
                    onChange={this.onChangePaginate}
                  />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                  {this.state.pageStart} {<FormattedMessage id="to" />}{" "}
                  {this.state.pageEnd} {<FormattedMessage id="of" />}{" "}
                  {this.state.count} {<FormattedMessage id="register" />}
                </Grid>
              </Grid>
            </Can>
            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

CalledClassifications.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(componentActions, dispatch);
export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(Styles)(CalledClassifications))
);
CalledClassifications.contextType = AbilityContext;
